import { useSentBatchesQuery } from '@/hooks/queries/use-sent-batches-query';
import { VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import SentBatchCard from './SentBatchCard';
import SentBatchListSkeleton from './SentBatchListSkeleton';

interface SentBatchListProps {
  searchQuery?: string;
}

const SentBatchList: React.FC<SentBatchListProps> = ({ searchQuery }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useSentBatchesQuery({ search: searchQuery || undefined });

  if (isLoading) {
    return <SentBatchListSkeleton />;
  }

  const batches = data?.data ?? [];

  if (batches.length === 0) {
    return null;
  }

  return (
    <VStack gap="1px" align="stretch" w="full">
      {batches.map((batch) => (
        <SentBatchCard
          key={batch.id}
          batch={batch}
          onClick={() => navigate(`/messages/sent/${batch.id}?messageFilter=sent`)}
        />
      ))}
    </VStack>
  );
};

export default SentBatchList;
